import endpoint from './endpoint.js';

export default { getToken, getUsers, createUser, updateUser, deleteUser, getProfile, updateProfile, unignoreElevator, adminGetIgnoredElevators, adminUnignoreElevator, getElevatorStats, getElevators, getElevator, getGroups, getGroup, createGroup, updateGroup, deleteGroup, updateElevator, getElevatorErrors, getElevatorInputs, getOutages, getElevatorOutages, getElevatorEvents, setRelay, getUnconnected, updateUnconnected, getOutage, getCurrentOutages, getCurrentElevatorOutages, getReport, getEvents, createEvent, putCall, putRepair, resetElevator, deleteElevator, getElevatorStatus, clearErrors, clearLog, getSettings, putSettings, putEvacGroup, putEvacElevator, putReset, sendMail, getMaintenancePlan, getPlannedMaintenances, putPlannedMaintenance, deletePlannedMaintenance, completeMaintenance, putPositionLabel, getActivities, createActivity };

endpoint.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  config.headers.Authorization = `Bearer ${token}`;
  return config;
})

function sendMail(data, cb) {
  endpoint.post('api/v1/support', data)
    .then(res => {
      cb({ status: res.status, data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });

}

function getToken(username, password, cb) {
  endpoint.post('/login', {
    'name': username,
    'password': password
  })
    .then(res => {
      cb({ token: res.data.token });
    })
    .catch(err => {
      console.log(err);
      cb({});
    });
}

function getUsers(cb) {
  endpoint.get('/api/v1/users')
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      console.log(err);
      cb({});
    });
}

function createUser(data, cb) {
  endpoint.post('api/v1/users', data)
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function updateUser(data, cb) {
  endpoint.put('api/v1/users', data)
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function unignoreElevator(elevatorID, cb) {
  endpoint.delete('api/v1/profile/ignored-elevators', { params: { elevator: elevatorID } })
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function adminGetIgnoredElevators(userID, cb) {
  endpoint.get(`api/v1/users/${userID}/ignored-elevators`)
    .then(res => { cb({ data: res.data }) })
    .catch(err => { cb({ data: { message: err.response.data.message } }) });
}

function adminUnignoreElevator(userID, elevatorID, cb) {
  endpoint.delete(`api/v1/users/${userID}/ignored-elevators`, { params: { elevator: elevatorID } })
    .then(res => { cb({ data: res.data }) })
    .catch(err => { cb({ data: { message: err.response.data.message } }) });
}

function updateProfile(data, cb) {
  endpoint.put('api/v1/profile', data)
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function getProfile(cb) {
  endpoint.get('api/v1/profile')
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({});
    });
}

function updateElevator(data, cb) {
  endpoint.put('api/v1/elevators', data)
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function deleteUser(id, cb) {
  endpoint.delete('api/v1/users', { params: { id: id } })
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function clearErrors(id, cb) {
  console.log("clear events for " + id);
  endpoint.delete('api/v1/errors', { params: { elevator: id } })
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function clearLog(id, cb) {
  endpoint.delete('api/v1/log', { params: { elevator: id } })
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function getGroups(cb) {
  endpoint.get('/api/v1/groups')
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      console.log(err);
      cb({});
    });
}

function getGroup(id, cb) {
  endpoint.get('/api/v1/groups', { params: { id } })
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      console.log(err);
      cb({});
    });
}

function createGroup(data, cb) {
  endpoint.post('api/v1/groups', data)
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function updateGroup(data, cb) {
  endpoint.put('api/v1/groups', data)
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function deleteGroup(id, cb) {
  endpoint.delete('api/v1/groups', { params: { id: id } })
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function getElevators(cb, window) {
  const params = window ? { avg_window: window } : {}
  endpoint.get('/api/v1/elevators', { params })
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      console.log(err);
      cb({});
    });
}

function getElevator(id, cb) {
  endpoint.get('/api/v1/elevators', { params: { id } })
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      console.log(err);
      cb({});
    });
}

function getElevatorStats(id, from, to, cb) {
  var url = "/api/v1/stats?elevator=" + id;

  if (from) {
    url += "&from=" + (new Date(from)).toISOString();
  }

  if (to) {
    url += "&to=" + (new Date(to)).toISOString();
  }

  endpoint.get(url)
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({});
    });
}

function getElevatorErrors(id, cb) {
  var url = "/api/v1/errors?elevator=" + id;

  endpoint.get(url)
    .then(res => {
      cb({ status: res.status, data: res.data })
    })
    .catch(err => {
      cb({ status: err.response.status, data: err.response.data });
    });
}

function getElevatorInputs(id, group, cb) {
  var url = "/api/v1/inputs?elevator=" + id;

  if (group !== undefined && group !== "") {
    url = url + "&group=" + group;
  }

  endpoint.get(url)
    .then(res => {
      console.log(res);
      cb({ status: res.status, data: res.data })
    })
    .catch(err => {
      cb({ status: err.response.status, data: err.response.data });
    });
}

function getOutages(from, to, cursor, perPage, minDuration, filters, cb) {
  var params = new URLSearchParams();

  if (from) params.append('from', (new Date(from)).toISOString());
  if (to) params.append('to', (new Date(to)).toISOString());
  if (cursor) params.append('cursor', cursor);
  if (perPage) params.append('per_page', perPage);
  if (minDuration > 0) params.append('min_duration', minDuration * 60);
  if (filters) {
    if (filters.elevatorTypes && filters.elevatorTypes.length) {
      filters.elevatorTypes.forEach(t => params.append('elevator_types[]', t));
    }
    if (filters.text) params.append('text', filters.text);
  }

  endpoint.get('/api/v1/outages?' + params.toString())
    .then(res => { cb({ data: res.data }) })
    .catch(err => { console.log(err); cb({}); });
}

function getEvents(from, to, cursor, perPage, filters, cb) {
  var params = new URLSearchParams();

  if (from) params.append('from', (new Date(from)).toISOString());
  if (to) params.append('to', (new Date(to)).toISOString());
  if (cursor) params.append('cursor', cursor);
  if (perPage) params.append('per_page', perPage);
  if (filters) {
    if (filters.eventTypes && filters.eventTypes.length) {
      filters.eventTypes.forEach(t => params.append('event_types[]', t));
    }
    if (filters.elevatorTypes && filters.elevatorTypes.length) {
      filters.elevatorTypes.forEach(t => params.append('elevator_types[]', t));
    }
    if (filters.text) params.append('text', filters.text);
  }

  endpoint.get('/api/v1/events?' + params.toString())
    .then(res => { cb({ data: res.data }) })
    .catch(err => { console.log(err); cb({}); });
}

function createEvent(id, data, cb) {
  data.elevator_id = id;
  endpoint.post('api/v1/events', data)
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function getCurrentOutages(cb) {
  endpoint.get('/api/v1/outages?current=true')
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      console.log(err);
      cb({});
    });
}

function getCurrentElevatorOutages(id, cb) {
  endpoint.get('/api/v1/outages?elevator=' + id)
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      console.log(err);
      cb({});
    });
}

function getOutage(id, cb) {
  endpoint.get('/api/v1/outages?id=' + id)
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      console.log(err);
      cb({});
    });
}

function getUnconnected(cb) {
  var url = "/api/v1/unconnected";

  endpoint.get(url)
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      console.log(err);
      cb({});
    });
}

function updateUnconnected(host, type, options, cb) {
  endpoint.put('/api/v1/unconnected', {
    "host": host,
    "type": type,
    "options": options
  })
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function getElevatorEvents(id, from, to, cursor, perPage, cb) {
  var params = new URLSearchParams();
  params.append('elevator', id);
  if (from) params.append('from', (new Date(from)).toISOString());
  if (to) params.append('to', (new Date(to)).toISOString());
  if (cursor) params.append('cursor', cursor);
  if (perPage) params.append('per_page', perPage);

  endpoint.get('/api/v1/events?' + params.toString())
    .then(res => { cb({ data: res.data }) })
    .catch(err => { console.log(err); cb({}); });
}

function getElevatorOutages(id, from, to, cursor, perPage, cb) {
  var params = new URLSearchParams();
  params.append('elevator', id);
  if (from) params.append('from', (new Date(from)).toISOString());
  if (to) params.append('to', (new Date(to)).toISOString());
  if (cursor) params.append('cursor', cursor);
  if (perPage) params.append('per_page', perPage);

  endpoint.get('/api/v1/outages?' + params.toString())
    .then(res => { cb({ data: res.data }) })
    .catch(err => { console.log(err); cb({}); });
}

function putCall(elevator, position, cb) {
  var data = {
    "elevator": elevator,
    "position": position
  }

  endpoint.put('api/v1/call', data)
    .then(res => {
      cb({ status: 200, data: res.data })
    })
    .catch(err => {
      console.log(err);
      var data = JSON.parse(err.response.data);
      var status = err.response.status;
      cb({ status: status, data: data });
    });
}

function putRepair(elevator, repair, cb) {
  var data = {
    "elevator": elevator,
    "repair": repair,
  }

  endpoint.put('api/v1/repair', data)
    .then(res => {
      cb({ status: 200, data: res.data })
      //console.log(res);
      //var data = JSON.parse(res.data);
      //var status = res.status;
      //cb({status: status, data: data});
    })
    .catch(err => {
      //var st  = err.response.status;
      //console.log(st);
      //var data = JSON.parse(err.response.data);
      cb({ status: err.response.status, data: err.response.data });
    });
}

function putReset(elevator, cb) {
  var data = {
    "elevator": elevator,
  }

  endpoint.put('api/v1/resetc', data)
    .then(res => {
      cb({ status: res.status, data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function setRelay(elevator, relay, value, cb) {
  var data = {
    "elevator": elevator,
    "relay": relay,
    "value": value
  }

  endpoint.put('api/v1/relay', data)
    .then(res => {
      cb({ status: 200, data: res.data })
    })
    .catch(err => {
      console.log(err);
      var data = JSON.parse(err.response.data);
      var status = err.response.status;
      cb({ status: status, data: data });
    });
}

function getReport(data, cb) {
  endpoint.post('api/v1/report.pdf', data, { 'responseType': 'blob' })
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function deleteElevator(id, cb) {
  endpoint.delete('api/v1/elevators', { params: { id: id } })
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      cb({ data: { message: err.response.data.message } });
    });
}

function resetElevator(id, cb) {
  endpoint.put('api/v1/reset', { id: id })
    .then(res => {
      cb({ status: 200, data: res.data })
    })
    .catch(err => {
      cb({ status: err.response.status, data: err.response.data });
    });
}

function getElevatorStatus(id, cb) {
  var url = "/api/v1/status?elevator=" + id;

  endpoint.get(url)
    .then(res => {
      cb({ status: res.status, data: res.data })
    })
    .catch(err => {
      cb({ status: err.response.status, data: err.response.data });
    });
}

function getSettings(cb) {
  endpoint.get('/api/v1/settings')
    .then(res => {
      cb({ data: res.data })
    })
    .catch(err => {
      console.log(err);
      cb({});
    });
}

function putSettings(data, cb) {
  endpoint.put('/api/v1/settings', data)
    .then(res => { cb({ data: res.data }) })
    .catch(() => { cb({}) })
}

function putEvacGroup(id, evac, cb) {
  var data = {
    "id": id,
    "evac": evac,
  }

  endpoint.put('api/v1/evacgroup', data)
    .then(res => {
      cb({ status: 200, data: res.data })
      //console.log(res);
      //var data = JSON.parse(res.data);
      //var status = res.status;
      //cb({status: status, data: data});
    })
    .catch(err => {
      //var st  = err.response.status;
      //console.log(st);
      //var data = JSON.parse(err.response.data);
      cb({ status: err.response.status, data: err.response.data });
    });
}

function putEvacElevator(id, evac, cb) {
  var data = {
    "id": id,
    "evac": evac,
  }

  endpoint.put('api/v1/evac', data)
    .then(res => {
      cb({ status: 200, data: res.data })
      //console.log(res);
      //var data = JSON.parse(res.data);
      //var status = res.status;
      //cb({status: status, data: data});
    })
    .catch(err => {
      //var st  = err.response.status;
      //console.log(st);
      //var data = JSON.parse(err.response.data);
      cb({ status: err.response.status, data: err.response.data });
    });
}

function getMaintenancePlan(cb) {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  endpoint.get('api/v1/maintenance', { params: { tz } })
    .then(res => { cb({ data: res.data }) })
    .catch(() => { cb({}) });
}

function getPlannedMaintenances(cb) {
  endpoint.get('api/v1/maintenance/planned')
    .then(res => { cb({ data: res.data }) })
    .catch(() => { cb({}) });
}

function putPlannedMaintenance(elevatorId, data, cb) {
  endpoint.put(`api/v1/maintenance/planned/${elevatorId}`, data)
    .then(res => { cb({ data: res.data }) })
    .catch(() => { cb({}) });
}

function deletePlannedMaintenance(elevatorId, cb) {
  endpoint.delete(`api/v1/maintenance/planned/${elevatorId}`)
    .then(() => { cb({ ok: true }) })
    .catch(() => { cb({}) });
}

function completeMaintenance(elevatorId, data, cb) {
  endpoint.post(`api/v1/maintenance/planned/${elevatorId}/complete`, data)
    .then(res => { cb({ data: res.data }) })
    .catch(() => { cb({}) });
}

function putPositionLabel(elevatorId, position, label, cb) {
  endpoint.put('api/v1/positions', { elevator: elevatorId, position, label })
    .then(res => { cb({ status: res.status, data: res.data }) })
    .catch(err => { cb({ status: err.response ? err.response.status : 500 }) });
}

function getActivities(from, to, cursor, perPage, filters, cb) {
  var params = new URLSearchParams();

  if (from) params.append('from', (new Date(from)).toISOString());
  if (to) params.append('to', (new Date(to)).toISOString());
  if (cursor) params.append('cursor', cursor);
  if (perPage) params.append('per_page', perPage);
  if (filters) {
    if (filters.actions && filters.actions.length) {
      filters.actions.forEach(a => params.append('actions[]', a));
    }
    if (filters.users && filters.users.length) {
      filters.users.forEach(u => params.append('users[]', u));
    }
    if (filters.text) params.append('text', filters.text);
  }

  endpoint.get('/api/v1/activities?' + params.toString())
    .then(res => { cb({ data: res.data }) })
    .catch(err => { console.log(err); cb({}); });
}

function createActivity(action, details, elevatorId) {
  endpoint.post("api/v1/activities", { action, details, elevator_id: elevatorId || "" });
}



// WEBPACK FOOTER //
// ./src/api.js